import React, { useEffect, useState } from "react";
import { FaBars, FaUserCircle } from "react-icons/fa";
import {jwtDecode} from "jwt-decode";              // ✅ default export
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = "https://api.vyapakprint.com/api";

const Navbar = ({ toggleSidebar }) => {
  const [user, setUser]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const navigate = useNavigate();

  /* ----------------------------------------------------------------
     EFFECT: grab token → decode → fetch user
  ---------------------------------------------------------------- */
  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem("token");

      /* no token → bounce to login */
      if (!token) {
        setLoading(false);
        return navigate("/login");
      }

      /* decode safely */
      let decoded;
      try {
        decoded = jwtDecode(token);
      } catch (err) {
        console.error("Bad JWT:", err);
        localStorage.removeItem("token");
        setLoading(false);
        return navigate("/login");
      }

      /* payload shapes differ across backends → pick the first truthy */
      const userId =
        decoded?.user?.userId || decoded?.userId || decoded?._id;

      if (!userId) {
        console.error("userId missing in token payload:", decoded);
        setError("Invalid token payload");
        setLoading(false);
        return;
      }

      /* fetch the user */
      try {
        const { data } = await axios.get(
          `${API}/distribution/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUser(data);
      } catch (err) {
        console.error("Error fetching user:", err);
        setError(
          err.response?.data?.message || "Failed to load user data"
        );
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [navigate]);

  /* ----------------------------------------------------------------
     LOGOUT
  ---------------------------------------------------------------- */
  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("token");
      navigate("/login");
      window.location.reload();
    }
  };

  /* ----------------------------------------------------------------
     RENDER
  ---------------------------------------------------------------- */
  if (loading) return <div className="text-white">Loading…</div>;
  if (error)   return <div className="text-red-500">Error: {error}</div>;
  if (!user)   return null; // extra safety

  return (
    <nav className="bg-gradient-to-r from-gray-800 via-gray-900 to-black p-4 text-white flex justify-between items-center shadow-2xl">
      {/* Sidebar toggle & brand */}
      <div className="flex items-center space-x-4">
        <button
          onClick={toggleSidebar}
          className="p-2 bg-gray-700 rounded-full hover:bg-gray-600"
        >
          <FaBars size={24} />
        </button>
        <h1 className="text-xl font-bold tracking-wider uppercase">
          vyapakprint Business
        </h1>
      </div>

      {/* User block */}
      <div className="flex items-center space-x-4">
        <FaUserCircle size={32} className="text-gray-400" />
        <div className="text-right">
          <p className="text-sm font-medium">
            Welcome&nbsp;Mr.&nbsp;{user.contactPerson}
          </p>
          <p className="text-xs text-gray-300">{user.businessName}</p>
        </div>
        <div className="text-sm text-right">
          <p>
            A/C Balance:&nbsp;
            <span className="font-bold">₹{user.wallet}</span>
          </p>
          <p>
            USER&nbsp;ID:&nbsp;
            <span className="font-bold">{user._id}</span>
          </p>
        </div>
        <button
          onClick={handleLogout}
          className="ml-4 bg-red-600 px-3 py-2 rounded hover:bg-red-500"
        >
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
